import moment from 'moment-timezone';
moment.relativeTimeThreshold('s', -1);
moment.relativeTimeThreshold('ss', 60);
moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 30);
moment.relativeTimeThreshold('w', 4);
moment.relativeTimeThreshold('M', 12);
// console.log('ss', moment.relativeTimeThreshold('ss')); // 44
// console.log('s', moment.relativeTimeThreshold('s'));  // 45
// console.log('m', moment.relativeTimeThreshold('m'));  // 45
// console.log('h', moment.relativeTimeThreshold('h'));  // 22
// console.log('d', moment.relativeTimeThreshold('d'));  // 26
// console.log('w', moment.relativeTimeThreshold('w'));  // null (disabled)
// console.log('M', moment.relativeTimeThreshold('M'));  // 11
export function presentableTime(value) {
    return value ? moment(value).format('D MMM YYYY HH:mm') : '-';
}
export function presentableLocalTime(value) {
    return value ? moment.utc(value).local().format('D MMM YYYY HH:mm') : '-';
}
export function formatDate(value) {
    return value ? moment(value).format('MMM D, YYYY') : '-';
}
export function formatShortDate(value) {
    return value ? moment(value).format('MMM YYYY') : '-';
}
export function removeTime(value) {
    return value ? moment(value).format('YYYY-MM-DD') : '';
}
export function formatDateAndTime(value) {
    return value ? moment(value).format('D MMM YYYY HH:mm') : '';
}
export function toLocalTime(value) {
    if (!value)
        return moment();
    return moment.utc(value).local();
}
export function toUTCTime(value) {
    if (!value)
        return moment();
    return moment(value).utc();
}
export function formatDateFromNow(value, translate = (a) => a, minInterval = 'day') {
    if (!value)
        return '';
    const daysToWeekMap = (value) => {
        const isDays = value.indexOf('days') > -1;
        let days = 0;
        try {
            days = parseInt(value.replace(/[^0-9]+/g, ''));
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
        if (isDays && days >= 7 && days <= 31) {
            return Math.floor(days / 7) === 1 ? translate('a week ago') : `${Math.floor(days / 7)} ${translate('weeks ago')}`;
        }
        return value;
    };
    const date = moment(moment.utc(value)).local();
    const now = moment(moment.utc()).local();
    if (minInterval === 'day' && date.isSame(now, 'day')) {
        return translate('Today');
    }
    if (date.startOf('day').diff(now.startOf('day'), 'days') === -1) {
        return translate('Yesterday');
    }
    return daysToWeekMap(date.from(now));
}
export function differenceBetweenTwoDates(firstDate, secnodDate) {
    if (!firstDate || !secnodDate)
        return '';
    const date = moment(moment.utc(firstDate)).local();
    const now = moment(moment.utc(secnodDate)).local();
    const duration = moment.duration(now.diff(date));
    if (duration.asDays() < 0)
        return '';
    return duration.humanize();
}
export function difference100Years(firstDate, secnodDate) {
    if (!firstDate || !secnodDate)
        return false;
    const startDate = moment(firstDate);
    const endDate = moment(secnodDate);
    const yearDiff = endDate.diff(startDate, 'years');
    return yearDiff > 100;
}
const UTC_AWARE_TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSSSSZ';
export const currentTimezone = moment.tz.guess();
export const getUtcFormatted = (dateTime) => dateTime && moment(dateTime).utc().format(UTC_AWARE_TIMESTAMP_FORMAT);
export const getDateTimeFormatted = (dateTime) => dateTime && moment(dateTime).format(UTC_AWARE_TIMESTAMP_FORMAT);
export const getLocalFormatted = (dateTime) => dateTime && moment.utc(dateTime).local().format(UTC_AWARE_TIMESTAMP_FORMAT);
export const getUtcFormattedFromLocal = (dateTime, timezone, format) => dateTime &&
    moment
        .utc(dateTime)
        .tz(timezone)
        .format(format || UTC_AWARE_TIMESTAMP_FORMAT);
